export default "__VITE_ASSET__D220SU3I__"